<template>
  <div class="card-body-container">
    <div class="anal-group-button-container">
      <div class="manage-button-container">
        <div class="action-container">
          <div class="left">
            <div class="v-select-container">
              <div class="title">{{ 'แหล่งข้อมูล : ' }}</div>
              <native-custom-selector
                :options="dropDownFormatStatus"
                label="label"
                v-model="formatStatus"
                :clear-option="clearCouponStatus"
                :searchable="false"
                :placeholder="'All'"
              />
            </div>
          </div>
          <div class="right">
            <div class="filters">
              <div class="date-range-picker">
                <choco-date-range-picker
                  class="choco-date-range-picker"
                  v-model:start="startDate"
                  v-model:end="endDate"
                  :relative-options="['today', 'P7D', 'P15D', 'P30D', 'P90D']"
                  v-model:relative-model="relativeModel"
                  :format="'dd MMM yyyy'"
                  :relative-title="t('date_picker.date_range')"
                  relative-title-class="font-f1"
                  @click="onClickDateSelect"
                  @hide="() => {}"
                  :is-show-apply-button="true"
                >
                  <template v-slot:input="props">
                    <date-range-display-input class="input" v-bind="props" prepend-icon />
                  </template>
                </choco-date-range-picker>
              </div>
              <div class="anl-reset-date-picker" @click="onResetDate" v-bt-tooltips :title="'reset'">
                <reset-icon />
              </div>
              <div class="export-button-container">
                <button
                  class="btn d-flex align-items-center"
                  v-bt-tooltips="{ bgColor: '#30a704', color: '#ffffff' }"
                  title="Export CSV."
                  :disabled="loadingExportCsv"
                  @click="onExportCSV"
                >
                  <template v-if="!loadingExportCsv">
                    <download-icon />
                  </template>
                  <template v-else>
                    <div class="spinner-border-container">
                      <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </template>
                </button>
              </div>
            </div>
            <base-button class="button-item" @on-click="onClickManageColumnButton">
              <template v-slot:prepend>
                <setting-column-icon />
              </template>
            </base-button>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container">
      <base-table
        :columns="fields"
        :data="listSegment"
        :current-page="pagination.currentPage"
        :per-pages="pagination.perPage"
        :busy="loading"
        responsive
        sortableCol
        hover
        @col-change="handleColumnChange"
        @sorting-change="onSort"
      >
        <template #cell(segmentName)="data">
          <div class="segment-name font-f2">{{ data.item.segmentName }}</div>
        </template>
        <template #cell(folder)="data">
          <div class="folder">{{ data.item.folder || '-' }}</div>
        </template>
        <template #cell(segmentSize)="data">
          <div class="segment-size">{{ data.item.segmentSize.toLocaleString() || '-' }}</div>
        </template>
        <template #cell(avgDayToChurn)="data">
          <div class="avg-day-to-churn">{{ data.item.avgDayToChurn.toLocaleString() + ' days' }}</div>
        </template>
        <template #cell(churnRate)="data">
          <div class="churn-rate">{{ data.item.churnRate + '%' + ' [' + (data.item.churnRate * 100).toLocaleString() + ']' }}</div>
        </template>
        <template #cell(riskChurn)="data">
          <div class="risk-churn">{{ data.item.riskChurn + '%' + ' [' + (data.item.riskChurn * 100).toLocaleString() + ']' }}</div>
        </template>
        <template #cell(lastUpdate)="data">
          <div>{{ convertDateTable(data.item.lastUpdate) || '-' }}</div>
        </template>
        <template #cell(churnValue)="data">
          <div v-if="false">{{ '-' }}</div>

          <div :class="true ? 'table-churn-value-red' : 'table-churn-value-green'" v-else>
            <div>{{ data.item.churnValue.toLocaleString() }}</div>
            <div v-if="true" class="table-icon-count"><DownCountIcon /></div>
            <div v-else class="table-icon-count"><UpCountIcon /></div>
          </div>
        </template>
        <template #cell(riskChurnValue)="data">
          <div v-if="false">{{ '-' }}</div>

          <div :class="false ? 'table-churn-red' : 'table-churn-green'" v-else>
            <div>{{ data.item.riskChurnValue.toLocaleString() }}</div>
            <div v-if="false" class="table-icon-count"><DownCountIcon /></div>
            <div v-else class="table-icon-count"><UpCountIcon /></div>
          </div>
        </template>
        <template #cell(segmentType)="data">
          <segment-type :type="resolveSegmentType(data.item.segmentType)" />
        </template>
        <template #cell(action)="data">
          <ActionList
            :actions="actionList"
            :button-tooltip="t('segment.all_segment.button.action')"
            :tooltip-color="'#007FFF'"
            :tooltip-background-color="'#BBDBFF'"
            @select-item="onSelectAction($event, data.item)"
          />
        </template>
        <template #busy>
          <loader-spinner />
        </template>
      </base-table>
    </div>
    <div class="pagination-container">
      <div class="d-flex justify-content-center align-items-center ps-5" style="height: fit-content">
        {{ t('communication.show') }}
        <v-select
          class="px-2"
          :modelValue="pagination.perPage"
          @update:modelValue="setPagination"
          :options="dropDownPagination"
          :clearable="false"
          :searchable="false"
        >
        </v-select>
        {{ t('communication.list') }}
      </div>

      <pagination
        class="pe-5"
        style="padding-top: 0.313rem"
        :key="pagination.perPage"
        v-model="pagination.currentPage"
        :totalRows="pagination.totalRows"
        :perPages="pagination.perPage"
      />
    </div>
  </div>
  <ManageColumnModal
    :is-open="isOpenManageColumnModal"
    :loading="false"
    :column-value="fields"
    @close-modal="onCloseManageColumnModal"
    @apply-modal="onApplyManageColumnModal"
  />
</template>
<script setup lang="ts">
import { onBeforeMount, ref, Ref, reactive, markRaw } from 'vue';
import router from '@/router';
import { useI18n } from 'vue-i18n';
import { ChocoDateRangePicker } from '@choco-platform/components';

import DateRangeDisplayInput from '@/views/components/date-display-input/DateRangeDisplayInput.vue';
import NativeCustomSelector from '@/views/components/custom-v-select/NativeCustomSelector.vue';
import BaseButton from '@/views/components/button/BaseButton.vue';
import LoaderSpinner from '@/views/components/loader/loader-spinner.vue';
import ActionList from '@/views/components/action-list/ActionList.vue';
import BaseTable from '@/views/components/table/base-table/BaseTable.vue';
import Pagination from '@/views/components/pagination/Pagination.vue';
import DetailAnalIcon from '@/assets/icons/modules/analytics/churn-rate/DetailAnalIcon.vue';
import SettingColumnIcon from '@/assets/icons/base/button/SettingColumnIcon.vue';
import useFilters from '@/utils/hooks/useFilters';
import useConvertDate from '@/utils/hooks/useConvertDate';
import ManageColumnModal from './ManageColumnModal.vue';
import SegmentType from './SegmentType.vue';
import ResetIcon from '@/assets/icons/modules/analytics/bi/ResetIcon.vue';
import useValidationModal from '@/views/components/modal/hooks/useValidationModal';
import DownloadIcon from '@assets/icons/modules/analytics/bi/DownloadIcon.vue';
import UpCountIcon from '@/assets/icons/modules/analytics/churn-rate/UpCountIcon.vue';
import DownCountIcon from '@/assets/icons/modules/analytics/churn-rate/DownCountIcon.vue';
const { t } = useI18n();
const { openErrorModal } = useValidationModal();

const { convertDate } = useConvertDate();
const { filterDisplayObj } = useFilters();
const isOpenManageColumnModal: Ref<boolean> = ref(false);
const loading: Ref<boolean> = ref(false);
const dropDownPagination = ref([5, 10, 15, 20]);
const startDate: Ref<Date | null> = ref(null);
const endDate: Ref<Date | null> = ref(null);
const DEFAULT_DATE_FILTER = 'P90D';
const relativeModel: Ref<string | null> = ref(DEFAULT_DATE_FILTER);
const loadingExportCsv: Ref<boolean> = ref(false);
const dropDownFormatStatus: Ref<Record<string, any>[]> = ref([
  { Seq: 1, Key: 'Format', label: 'ChocoCRM', valueStatus: 1 },
  { Seq: 2, Key: 'Format', label: 'ChocoPOS', valueStatus: 2 },
  { Seq: 3, Key: 'Format', label: 'Fasthelp5', valueStatus: 3 },
]);
const formatStatus: Ref<Record<string, any>> = ref(null!);
const fields: Ref<BaseTable.TableColumn[]> = ref([
  { key: 'segmentName', label: 'Segment Name', selected: true },
  { key: 'folder', label: 'Folder', selected: true },
  { key: 'segmentSize', label: 'Segment Size', selected: true },
  { key: 'segmentType', label: 'Segment Type', selected: true },
  { key: 'avgDayToChurn', label: 'Avg. Day To Churn', selected: true },
  { key: 'churnRate', label: 'Churn Rate', selected: true },
  { key: 'riskChurn', label: 'Risk Churn', selected: true },
  { key: 'churnValue', label: 'Churn Value', selected: true },
  { key: 'riskChurnValue', label: 'Risk Churn Value', selected: true },
  { key: 'lastUpdate', label: 'Last Update', selected: true },
  { key: 'churnAvgValue', label: 'Churn Avg. Value', selected: false },
  { key: 'riskChurnAvgValue', label: 'Risk Churn Avg. Value', selected: false },
  { key: 'winBackCustomer', label: 'Win-Back Customer %', selected: false },
  { key: 'winBackValue', label: 'Win-Back Value', selected: false },
  { key: 'winBackAvgValue', label: 'Win-Back Avg. Value', selected: false },
  { key: 'actualWinBackValue', label: 'Actual Win-Back Value', selected: false },
  { key: 'lostPerHead', label: 'Lost Per Head', selected: false },
  { key: 'avgLostPerHead', label: 'Avg. Lost Per Head', selected: false },
  { key: 'action', label: '', selected: true },
]);

// selectedColumns.value.push({ key: 'action', label: '', selected: true });
const listSegment: Ref<Record<string, any>[]> = ref([]);
const filtersObj: Ref<Array<any>> = ref([]);
const actionList: ActionList.Action[] = [];
const orderingSeq: Ref<number> = ref(0);
const orderingDirection: Ref<string> = ref('');
const orderingKey: Ref<string> = ref('');
const textSearch: Ref<string> = ref('');
const pagination: BaseTable.Pagination = reactive({
  currentPage: 1,
  perPage: 10,
  totalRows: 0,
});
const clearCouponStatus = ref(false);
const isMainFilterChanged: Ref<boolean> = ref(false);
const onResetDate = async () => {
  // dynamicFilter.value = [];
  // dynamicChartFilter.value = [];
  // if (startDate.value == null && endDate.value == null) return;
  // if (relativeModel.value == 'P90D') {
  //   endDate.value = new Date();
  //   startDate.value = new Date(new Date().setDate(endDate.value.getDate() - 90));
  // } else {
  //   endDate.value = new Date();
  //   startDate.value = new Date(new Date().setDate(endDate.value.getDate() - 30));
  // }
  // onClickDateSelect();
  // await fetchBiGlobalFilter();
  // await nextTick(() => {
  //   isMainFilterChanged.value = false;
  //   setAllSeen(false);
  //   fetchLayoutBi(pageIdActive.value);
  // });
};
const onClickDateSelect = () => {
  isMainFilterChanged.value = true;
};

function handleColumnChange(col: any) {
  fields.value = col;
}

function onClickManageColumnButton() {
  isOpenManageColumnModal.value = true;
}

function onCloseManageColumnModal() {
  isOpenManageColumnModal.value = false;
}
function onApplyManageColumnModal(data: any) {
  fields.value = data;
  isOpenManageColumnModal.value = false;
}

function fetchDatasourceDisplay() {
  listSegment.value = [
    {
      segmentName: 'Segment 1',
      folder: 'Folder A',
      segmentSize: 1000,
      segmentType: 1,
      avgDayToChurn: 30,
      churnRate: 5,
      riskChurn: 3,
      churnValue: 20000,
      riskChurnValue: 15000,
      lastUpdate: '2024-08-01',
      churnAvgValue: 10,
      riskChurnAvgValue: 10,
      winBackCustomer: 0,
      winBackValue: 0,
      winBackAvgValue: 0,
      actualWinBackValue: 0,
      lostPerHead: 1,
      avgLostPerHead: 1,
      action: '',
    },
    {
      segmentName: 'Segment 2',
      folder: 'Folder B',
      segmentSize: 1100,
      segmentType: 2,
      avgDayToChurn: 35,
      churnRate: 7,
      riskChurn: 1,
      churnValue: 21000,
      riskChurnValue: 15800,
      lastUpdate: '2024-08-02',
      churnAvgValue: 11,
      riskChurnAvgValue: 11,
      winBackCustomer: 1,
      winBackValue: 2,
      winBackAvgValue: 2,
      actualWinBackValue: 3,
      lostPerHead: 2,
      avgLostPerHead: 2,
      action: '',
    },
    {
      segmentName: 'Segment 3',
      folder: 'Folder C',
      segmentSize: 1200,
      segmentType: 3,
      avgDayToChurn: 40,
      churnRate: 9,
      riskChurn: 4,
      churnValue: 22000,
      riskChurnValue: 16600,
      lastUpdate: '2024-08-03',
      churnAvgValue: 12,
      riskChurnAvgValue: 12,
      winBackCustomer: 2,
      winBackValue: 4,
      winBackAvgValue: 4,
      actualWinBackValue: 6,
      lostPerHead: 3,
      avgLostPerHead: 3,
      action: '',
    },
    {
      segmentName: 'Segment 4',
      folder: 'Folder A',
      segmentSize: 1300,
      segmentType: 1,
      avgDayToChurn: 45,
      churnRate: 11,
      riskChurn: 12,
      churnValue: 23000,
      riskChurnValue: 17400,
      lastUpdate: '2024-08-04',
      churnAvgValue: 13,
      riskChurnAvgValue: 13,
      winBackCustomer: 3,
      winBackValue: 6,
      winBackAvgValue: 6,
      actualWinBackValue: 9,
      lostPerHead: 4,
      avgLostPerHead: 4,
      action: '',
    },
    {
      segmentName: 'Segment 5',
      folder: 'Folder B',
      segmentSize: 1400,
      segmentType: 2,
      avgDayToChurn: 50,
      churnRate: 13,
      riskChurn: 2,
      churnValue: 24000,
      riskChurnValue: 18200,
      lastUpdate: '2024-08-05',
      churnAvgValue: 14,
      riskChurnAvgValue: 14,
      winBackCustomer: 4,
      winBackValue: 8,
      winBackAvgValue: 8,
      actualWinBackValue: 12,
      lostPerHead: 5,
      avgLostPerHead: 5,
      action: '',
    },
    {
      segmentName: 'Segment 6',
      folder: 'Folder C',
      segmentSize: 1500,
      segmentType: 3,
      avgDayToChurn: 55,
      churnRate: 15,
      riskChurn: 3,
      churnValue: 25000,
      riskChurnValue: 19000,
      lastUpdate: '2024-08-06',
      churnAvgValue: 15,
      riskChurnAvgValue: 15,
      winBackCustomer: 5,
      winBackValue: 10,
      winBackAvgValue: 10,
      actualWinBackValue: 15,
      lostPerHead: 6,
      avgLostPerHead: 6,
      action: '',
    },
    {
      segmentName: 'Segment 7',
      folder: 'Folder A',
      segmentSize: 1600,
      segmentType: 1,
      avgDayToChurn: 60,
      churnRate: 17,
      riskChurn: 12,
      churnValue: 26000,
      riskChurnValue: 19800,
      lastUpdate: '2024-08-07',
      churnAvgValue: 16,
      riskChurnAvgValue: 16,
      winBackCustomer: 0,
      winBackValue: 12,
      winBackAvgValue: 12,
      actualWinBackValue: 18,
      lostPerHead: 7,
      avgLostPerHead: 7,
      action: '',
    },
    {
      segmentName: 'Segment 8',
      folder: 'Folder B',
      segmentSize: 1700,
      segmentType: 2,
      avgDayToChurn: 65,
      churnRate: 19,
      riskChurn: 11,
      churnValue: 27000,
      riskChurnValue: 20600,
      lastUpdate: '2024-08-08',
      churnAvgValue: 17,
      riskChurnAvgValue: 17,
      winBackCustomer: 1,
      winBackValue: 14,
      winBackAvgValue: 14,
      actualWinBackValue: 21,
      lostPerHead: 8,
      avgLostPerHead: 8,
      action: '',
    },
    {
      segmentName: 'Segment 9',
      folder: 'Folder C',
      segmentSize: 1800,
      segmentType: 3,
      avgDayToChurn: 70,
      churnRate: 21,
      riskChurn: 4,
      churnValue: 28000,
      riskChurnValue: 21400,
      lastUpdate: '2024-08-09',
      churnAvgValue: 18,
      riskChurnAvgValue: 18,
      winBackCustomer: 2,
      winBackValue: 16,
      winBackAvgValue: 16,
      actualWinBackValue: 24,
      lostPerHead: 9,
      avgLostPerHead: 9,
      action: '',
    },
    {
      segmentName: 'Segment 10',
      folder: 'Folder A',
      segmentSize: 1900,
      segmentType: 1,
      avgDayToChurn: 75,
      churnRate: 23,
      riskChurn: 6,
      churnValue: 29000,
      riskChurnValue: 22200,
      lastUpdate: '2024-08-10',
      churnAvgValue: 19,
      riskChurnAvgValue: 19,
      winBackCustomer: 3,
      winBackValue: 18,
      winBackAvgValue: 18,
      actualWinBackValue: 27,
      lostPerHead: 10,
      avgLostPerHead: 10,
      action: '',
    },
    {
      segmentName: 'Segment 11',
      folder: 'Folder B',
      segmentSize: 2000,
      segmentType: 2,
      avgDayToChurn: 80,
      churnRate: 25,
      riskChurn: 5,
      churnValue: 30000,
      riskChurnValue: 23000,
      lastUpdate: '2024-08-11',
      churnAvgValue: 20,
      riskChurnAvgValue: 20,
      winBackCustomer: 4,
      winBackValue: 20,
      winBackAvgValue: 20,
      actualWinBackValue: 30,
      lostPerHead: 11,
      avgLostPerHead: 11,
      action: '',
    },
    {
      segmentName: 'Segment 12',
      folder: 'Folder C',
      segmentSize: 2100,
      segmentType: 3,
      avgDayToChurn: 85,
      churnRate: 27,
      riskChurn: 3,
      churnValue: 31000,
      riskChurnValue: 23800,
      lastUpdate: '2024-08-12',
      churnAvgValue: 21,
      riskChurnAvgValue: 21,
      winBackCustomer: 5,
      winBackValue: 22,
      winBackAvgValue: 22,
      actualWinBackValue: 33,
      lostPerHead: 12,
      avgLostPerHead: 12,
      action: '',
    },
    {
      segmentName: 'Segment 13',
      folder: 'Folder A',
      segmentSize: 2200,
      segmentType: 1,
      avgDayToChurn: 90,
      churnRate: 29,
      riskChurn: 23,
      churnValue: 32000,
      riskChurnValue: 24600,
      lastUpdate: '2024-08-13',
      churnAvgValue: 22,
      riskChurnAvgValue: 22,
      winBackCustomer: 0,
      winBackValue: 24,
      winBackAvgValue: 24,
      actualWinBackValue: 36,
      lostPerHead: 13,
      avgLostPerHead: 13,
      action: '',
    },
    {
      segmentName: 'Segment 14',
      folder: 'Folder B',
      segmentSize: 2300,
      segmentType: 2,
      avgDayToChurn: 95,
      churnRate: 31,
      riskChurn: 21,
      churnValue: 33000,
      riskChurnValue: 25400,
      lastUpdate: '2024-08-14',
      churnAvgValue: 23,
      riskChurnAvgValue: 23,
      winBackCustomer: 1,
      winBackValue: 26,
      winBackAvgValue: 26,
      actualWinBackValue: 39,
      lostPerHead: 14,
      avgLostPerHead: 14,
      action: '',
    },
    {
      segmentName: 'Segment 15',
      folder: 'Folder C',
      segmentSize: 2400,
      segmentType: 3,
      avgDayToChurn: 100,
      churnRate: 33,
      riskChurn: 5,
      churnValue: 34000,
      riskChurnValue: 26200,
      lastUpdate: '2024-08-15',
      churnAvgValue: 24,
      riskChurnAvgValue: 24,
      winBackCustomer: 2,
      winBackValue: 28,
      winBackAvgValue: 28,
      actualWinBackValue: 42,
      lostPerHead: 15,
      avgLostPerHead: 15,
      action: '',
    },
    {
      segmentName: 'Segment 16',
      folder: 'Folder A',
      segmentSize: 2500,
      segmentType: 1,
      avgDayToChurn: 105,
      churnRate: 35,
      riskChurn: 7,
      churnValue: 35000,
      riskChurnValue: 27000,
      lastUpdate: '2024-08-16',
      churnAvgValue: 25,
      riskChurnAvgValue: 25,
      winBackCustomer: 3,
      winBackValue: 30,
      winBackAvgValue: 30,
      actualWinBackValue: 45,
      lostPerHead: 16,
      avgLostPerHead: 16,
      action: '',
    },
    {
      segmentName: 'Segment 17',
      folder: 'Folder B',
      segmentSize: 2600,
      segmentType: 2,
      avgDayToChurn: 110,
      churnRate: 37,
      riskChurn: 21,
      churnValue: 36000,
      riskChurnValue: 27800,
      lastUpdate: '2024-08-17',
      churnAvgValue: 26,
      riskChurnAvgValue: 26,
      winBackCustomer: 4,
      winBackValue: 32,
      winBackAvgValue: 32,
      actualWinBackValue: 48,
      lostPerHead: 17,
      avgLostPerHead: 17,
      action: '',
    },
    {
      segmentName: 'Segment 18',
      folder: 'Folder C',
      segmentSize: 2700,
      segmentType: 3,
      avgDayToChurn: 115,
      churnRate: 39,
      riskChurn: 24,
      churnValue: 37000,
      riskChurnValue: 28600,
      lastUpdate: '2024-08-18',
      churnAvgValue: 27,
      riskChurnAvgValue: 27,
      winBackCustomer: 5,
      winBackValue: 34,
      winBackAvgValue: 34,
      actualWinBackValue: 51,
      lostPerHead: 18,
      avgLostPerHead: 18,
      action: '',
    },
    {
      segmentName: 'Segment 19',
      folder: 'Folder A',
      segmentSize: 2800,
      segmentType: 1,
      avgDayToChurn: 120,
      churnRate: 41,
      riskChurn: 42,
      churnValue: 38000,
      riskChurnValue: 29400,
      lastUpdate: '2024-08-19',
      churnAvgValue: 28,
      riskChurnAvgValue: 28,
      winBackCustomer: 0,
      winBackValue: 36,
      winBackAvgValue: 36,
      actualWinBackValue: 54,
      lostPerHead: 19,
      avgLostPerHead: 19,
      action: '',
    },
    {
      segmentName: 'Segment 20',
      folder: 'Folder B',
      segmentSize: 2900,
      segmentType: 2,
      avgDayToChurn: 125,
      churnRate: 43,
      riskChurn: 13,
      churnValue: 39000,
      riskChurnValue: 30200,
      lastUpdate: '2024-08-20',
      churnAvgValue: 29,
      riskChurnAvgValue: 29,
      winBackCustomer: 1,
      winBackValue: 38,
      winBackAvgValue: 38,
      actualWinBackValue: 57,
      lostPerHead: 20,
      avgLostPerHead: 20,
      action: '',
    },
  ];
  pagination.totalRows = listSegment.value.length;
  // if (props.selectedSource != null) {
  //   loading.value = true;
  //   TotalRecord.value = 0;
  //   controllers.push(new AbortController());
  //   for (let i = 0; i < controllers.length - 1; i++) {
  //     controllers[i].abort();
  //   }
  //   fetchAllCustomerListModel.payload.tableId = props.selectedSource.tableid;
  //   fetchAllCustomerListModel.payload.Filters = filtersObj.value;
  //   fetchAllCustomerListModel.payload.Page = pagination.currentPage;
  //   fetchAllCustomerListModel.payload.Limit = pagination.perPage;
  //   fetchAllCustomerListModel.signal = controllers[controllers.length - 1].signal;
  //   fetchAllCustomerListModel.payload.Search_Value = textSearch.value;
  //   fetchAllCustomerListModel.payload.Flag_Count = false;
  //   if (orderingDirection.value) {
  //     fetchAllCustomerListModel.payload.Ordering = [
  //       {
  //         Seq: orderingSeq.value,
  //         Key: orderingKey.value,
  //         Direction: orderingDirection.value,
  //       },
  //     ];
  //   } else {
  //     fetchAllCustomerListModel.payload.Ordering = [];
  //   }
  //   fetchCountData();
  //   api
  //     .apiRequest(fetchAllCustomerListModel)
  //     .then((response) => {
  //       dataSourceDisplaySave.value = response.data.datasourcedisplay;
  //       dataSourceDisplay.value = response.data.datasourcedisplay.columns;
  //       findUniqueKey(response.data.datasourcedisplay.columns);
  //       fields.value = response.data.datasourcedisplay.columns;
  //       listSegment.value = response.data.structuretable;
  //       if (response.status == 'success') {
  //         loading.value = false;
  //       }
  //     })
  //     .catch((err) => {
  //       if (!(err instanceof TypeError)) {
  //         openDefaultErrorModal(err);
  //         ++errorCountDatasource.value;
  //         if (err.status != 422 && errorCountDatasource.value < 5) {
  //           retryPayloadDatasource();
  //         } else {
  //           loading.value = false;
  //           openDefaultErrorModal(err);
  //         }
  //       }
  //     })
  //     .finally(() => {
  //       filtersObj.value = [];
  //     });
  // }
}

const onExportCSV = () => {
  loadingExportCsv.value = true;
  // exportFileCouponSet.payload.CouponId = router.currentRoute.value.query.couponId;
  // api
  //   .apiRequest(exportFileCouponSet)
  //   .then((response) => {
  //     const datesTime = new Date();
  //     saveAs(
  //       response,
  //       `CouponCode_Report_${
  //         detailCoupon.couponName
  //       }_${datesTime.getFullYear()}${datesTime.getMonth()}${datesTime.getDate()}_${datesTime.getHours()}${datesTime.getMinutes()}${datesTime.getSeconds()}.csv`,
  //     );
  //   })
  //   .catch((err) => {
  //     openErrorModal(err.data.error.locale['th-th'].title as string, err.data.error.locale['th-th'].message as string);
  //   })
  //   .finally(() => {
  //     loadingExportCsv.value = false;
  //   });
  setTimeout(() => {
    loadingExportCsv.value = false;
  }, 3000);
};

function setPagination(data: any) {
  pagination.currentPage = 1;
  pagination.perPage = data;
}
function onSort(sortedColumn: { key: string; direction: string }) {
  orderingSeq.value = 1;
  orderingKey.value = sortedColumn.key;
  orderingDirection.value = sortedColumn.direction;

  if (textSearch.value != '') {
    filtersObj.value = filterDisplayObj(fields.value, textSearch.value);
  }
  if (pagination.currentPage == 1) {
    fetchDatasourceDisplay();
  } else {
    pagination.currentPage = 1;
  }
}

function resolveSegmentType(type: Segment.SegmentType) {
  switch (type) {
    case 1:
      return 'Batch';
    case 2:
      return 'Realtime';
    case 3:
      return 'Custom';
  }
}
function onSelectAction(action: ActionList.Action, segment: Segment.Segment) {
  switch (action.key) {
    case 'detail':
      return router.push({
        path: '/analytics/churnRate/insight',
        query: {
          ...router.currentRoute.value.query,
        },
      });
    default:
      return;
  }
}
function convertDateTable(date: string) {
  const apiDate = new Date(date).toISOString();
  const addHours = new Date(apiDate).getTime() + 7 * 60 * 60 * 1000;
  const result = new Date(addHours).toISOString();
  return convertDate(result);
}

function checkPermissionSegment() {
  if (true) {
    actionList.push({
      key: 'detail',
      tooltip: 'Detail',
      icon: DetailAnalIcon,
      tooltipColor: '#007FFF',
      tooltipBackgroundColor: '#BBDBFF',
    });
  }
  fetchDatasourceDisplay();
}
onBeforeMount(() => {
  checkPermissionSegment();
});
</script>

<style lang="scss" scoped>
.card-body-container {
  background-color: #fff;
  width: 100%;
  min-height: 40rem;
  margin-bottom: 5rem;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;

  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  .anal-group-button-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    .title-container {
      span {
        font-family: Prompt;
        font-size: 20px;
        font-weight: 500;
        text-align: left;
      }
    }
    .manage-button-container {
      .action-container {
        display: flex;
        justify-content: space-between;
        width: 100%;
        min-height: 5rem;
        background-color: #fff;
        border-bottom-left-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;

        .left {
          display: flex;
          align-items: center;
          width: 25rem;
          margin-left: 20px;
          .v-select-container {
            display: flex;
            width: 100%;
            align-items: center;
            gap: 10px;
            .native-custom-selector {
              width: 70%;
            }
            .title {
              font-size: 16px;
              color: #00000080;
            }

            .select {
              .v-select {
                position: relative;
                width: 17rem;
                height: 2.5rem;
                &:deep(.vs__dropdown-toggle) {
                  background-color: white;
                  height: 100%;
                  border-radius: 10px;
                  border: 1px solid #ededed;
                  transition: 0.25s;
                  --vs-search-input-placeholder-color: lightgrey;

                  &:hover {
                    box-shadow: 0 0 1rem lightgrey;
                  }
                }

                &:deep(.vs__dropdown-toggle):before {
                  content: '';
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 3rem;
                  height: 100%;
                  background-position-x: center;
                  background-position-y: 65%;
                  background-repeat: no-repeat;
                  background-image: url('data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfMzcwMTIiIGRhdGEtbmFtZT0iR3JvdXAgMzcwMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIxNy4yMTgiIGhlaWdodD0iMTMuNjYiIHZpZXdCb3g9IjAgMCAxNy4yMTggMTMuNjYiPg0KICA8ZyBpZD0iR3JvdXBfMzcwMTItMiIgZGF0YS1uYW1lPSJHcm91cCAzNzAxMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+DQogICAgPHBhdGggaWQ9IlBhdGhfMjQwNjgiIGRhdGEtbmFtZT0iUGF0aCAyNDA2OCIgZD0iTTE0LjQ0Nyw4LjExOGEyLjc3NSwyLjc3NSwwLDAsMC0yLjYzOCwxLjkyNiwyLjY0NiwyLjY0NiwwLDAsMS0xLjQ0Mi0yLjA3MUw5LjgyNCw1LjM2N2E1LjI4OSw1LjI4OSwwLDAsMC0uNzMtMS44MTJoMi43YTIuNzcxLDIuNzcxLDAsMSwwLDAtMS41NjlINS40MjdhMi43NzEsMi43NzEsMCwxLDAsMCwxLjU2OUg2LjQ4OWMuOCwwLDEuNTM3Ljg3NywxLjgsMi4xMzJsLjU0MywyLjYwNmEzLjksMy45LDAsMCwwLDIuOTUyLDMuMzUsMi43NywyLjc3LDAsMSwwLDIuNjY0LTMuNTI1TTIuNzcxLDMuOTczYTEuMiwxLjIsMCwxLDEsMS4yLTEuMiwxLjIsMS4yLDAsMCwxLTEuMiwxLjJtMTEuNjc2LTIuNGExLjIsMS4yLDAsMSwxLTEuMiwxLjIsMS4yLDEuMiwwLDAsMSwxLjItMS4ybTAsMTAuNTIyYTEuMiwxLjIsMCwxLDEsMS4yLTEuMiwxLjIsMS4yLDAsMCwxLTEuMiwxLjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIGZpbGw9IiM1NTUiLz4NCiAgPC9nPg0KPC9zdmc+DQo=');
                }

                --vs-dropdown-option--active-bg: transparent;
                --vs-dropdown-option--active-color: #000;
                --vs-dropdown-option--deselect-bg: transparent;
                --vs-dropdown-option--deselect-color: #000;
              }
            }
          }
        }

        .right {
          display: flex;
          align-items: center;
          margin-right: 20px;

          .filters {
            display: flex;
            align-items: center;

            .date-range-picker {
              max-width: 20rem;

              .choco-date-range-picker {
                margin: 0 0.5rem;
                position: relative;

                .title {
                  position: absolute;
                  top: 0;
                  transform: translateY(-1.5rem);
                }

                .input {
                  background-color: white;
                  max-width: 290px;
                  min-width: 290px;
                  width: 100%;
                }
              }
            }

            .anl-reset-date-picker {
              min-width: 25px;
              width: 25px;
              height: 25px;
              background-color: rgb(96, 106, 108, 0.15);
              border-radius: 50%;
              margin-right: 0.5rem;
              display: flex;
              cursor: pointer;
              transition: 0.2s all;

              &:hover {
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                background-color: rgb(96, 106, 108, 0.3);

                svg {
                  transform: rotate(45deg);
                }
              }

              svg {
                width: 15px;
                height: 14px;
                margin: auto;
                transition: 0.2s transform;
              }
            }

            .anl-filter-btn {
              border-radius: 8px;
            }
          }
          .chart-action {
            display: flex;

            .anl-action-wrp {
              .create-anl-button {
                border-radius: 0.5rem;

                .add-icon {
                  background: transparent;
                  margin-right: 0.5rem;

                  svg {
                    width: 20px;
                    fill: #007fff;
                  }
                }

                &:hover {
                  .add-icon {
                    svg {
                      fill: white;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .segment-name {
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #007fff;
    cursor: pointer;

    &:hover {
      color: #007fff !important;
    }
  }
  .pagination-container {
    margin-top: 2rem;
    margin-bottom: 2rem;
    display: flex;
    justify-content: space-between;
    :deep(.base-pagination) {
      margin-right: 1rem !important;
    }
  }
  .table-container {
    width: 100%;
    margin-top: 0rem;
    overflow: auto;
  }
  .button-item.base-button {
    margin-right: 0.625rem;
  }

  .table-churn-value-red {
    display: flex;
    color: #07964b;
  }
  .table-churn-value-green {
    display: flex;
    color: #ff2133;
  }
  .table-churn-red {
    display: flex;
    color: #07964b;
  }
  .table-churn-green {
    display: flex;
    color: #ff2133;
  }
  .table-icon-count {
    width: 13px;
    height: 13px;
    margin-left: 1rem;
  }
  .spinner-border-container {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #30a704;
    height: 100%;
    width: 100%;
  }
  .spinner-border {
    height: 60%;
  }
  .export-button-container {
    .btn {
      color: #ffffff;
      background-color: #ffffff;
      border-color: #efefef;
      border-radius: 0.5rem;
      width: 43px;
      height: 43px;
    }
    .btn:hover {
      color: #fff;
      background-color: #30a704;
      border-color: #30a704;
      svg {
        fill: #ffffff;
      }
    }
  }
}
</style>
